import { FindCollectionStrategyEnum, PublishStatusEnum } from 'lingo2-models';
import { ICollectionTab } from './models';

export const tabs: ICollectionTab[] = [
  {
    id: 'published',
    title: 'publish-status.published',
    stub: {
      tutor: 'my-library.stub.stub1_published_tutor',
      student: 'my-library.stub.stub1_published_student',
      stub_guest: 'my-library.stub.stub1_published_guest',
    },
    filter: {
      use: FindCollectionStrategyEnum.owned,
      publish_status: [PublishStatusEnum.published],
    },
  },
  {
    id: 'private',
    title: 'publish-status.private',
    stub: {
      tutor: 'my-library.stub.stub1_private_tutor',
      student: 'my-library.stub.stub1_private_student',
      stub_guest: 'my-library.stub.stub1_private_guest',
    },
    filter: {
      use: FindCollectionStrategyEnum.owned,
      publish_status: [PublishStatusEnum.private],
    },
  },
  {
    id: 'purchased',
    title: 'publish-status.purchased',
    stub: {
      tutor: 'my-library.stub.stub1_purchased_tutor',
      student: 'my-library.stub.stub1_purchased_student',
      stub_guest: 'my-library.stub.stub1_purchased_guest',
    },
    filter: {
      use: FindCollectionStrategyEnum.purchased,
      // ??? publish_status: [PublishStatusEnum.published],
    },
  },
  {
    id: 'moderation',
    title: 'publish-status.moderation',
    stub: {
      tutor: 'my-library.stub.stub1_moderation_tutor',
      student: 'my-library.stub.stub1_moderation_student',
      stub_guest: 'my-library.stub.stub1_moderation_guest',
    },
    filter: {
      use: FindCollectionStrategyEnum.owned,
      publish_status: [PublishStatusEnum.moderation],
    },
  },
  {
    id: 'draft',
    title: 'publish-status.draft',
    stub: {
      tutor: 'my-library.stub.stub1_draft_tutor',
      student: 'my-library.stub.stub1_draft_student',
      stub_guest: 'my-library.stub.stub1_draft_guest',
    },
    filter: {
      use: FindCollectionStrategyEnum.owned,
      publish_status: [PublishStatusEnum.draft],
    },
  },
  {
    id: 'archive',
    title: 'publish-status.archive',
    stub: {
      tutor: 'my-library.stub.stub1_archive_tutor',
      student: 'my-library.stub.stub1_archive_student',
      stub_guest: 'my-library.stub.stub1_archive_guest',
    },
    filter: {
      use: FindCollectionStrategyEnum.owned,
      publish_status: [PublishStatusEnum.archive],
    },
  },
];
